import React from 'react';
import { useDispatch } from 'react-redux';

export default function ProjectSalesCardTable({
  collection,
  tabs,
  isReadOnly = false,
}) {
  const {
    product: { updateSales },
  } = useDispatch();

  return (
    <div className="w-full">
      {collection.map((product) => (
        <div key={product.id} className="w-full mt-8">
          <div className="bmc-page-tabs-content-list-item-small-title items-start text-start">
            {product.name || tabs.productName}
          </div>

          <div className="w-full overflow-x-auto overflow-y-hidden max-w-none h-full">
            <table className="table-auto border-separate border-spacing-0 w-max min-w-full">
              <thead className="w-full">
                <tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
                    (headItem, headItemIdx) => (
                      <th
                        key={headItemIdx}
                        className="p-2 min-w-16 text-center text-sm whitespace-nowrap"
                      >
                        {tabs.monthAbbreviation} {headItem}
                      </th>
                    ),
                  )}
                </tr>
              </thead>
              <tbody className="w-full">
                <tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
                    (bodyItem, bodyItemIdx) => {
                      const isFirst = bodyItemIdx === 0;
                      const isLast = bodyItemIdx === 11;

                      return (
                        <td
                          key={bodyItemIdx}
                          className={`p-1 py-1.5 text-center border border-muted-darker bg-muted-lighter ${
                            isFirst ? 'rounded-l-md' : ''
                          } ${isLast ? 'rounded-r-md' : ''}`}
                        >
                          <div className="input-wrap relative">
                            {/* This span acts as a "measuring stick" - it contains the same text as the input but is invisible. The browser calculates its natural width based on the content. */}
                            <span
                              className="width-machine p-2 text-center text-slate-900 invisible whitespace-nowrap"
                              aria-hidden="true"
                            >
                              {product.sales[bodyItemIdx] ?? 0}
                            </span>
                            <input
                              type="text"
                              disabled={isReadOnly}
                              value={product.sales[bodyItemIdx] ?? 0}
                              onChange={(e) => {
                                const { value } = e.target;
                                // Only allow positive numbers (including decimals)
                                const positiveNumberRegex = /^[0-9]*\.?[0-9]*$/;
                                if (value && !positiveNumberRegex.test(value)) {
                                  e.target.value =
                                    product.sales[bodyItemIdx] ?? 0;
                                  return;
                                }

                                // Defining a limit as parseInt can deal with a limited number
                                const maxSafeNumberStringLength = 12;
                                if (
                                  value &&
                                  value.length > maxSafeNumberStringLength
                                ) {
                                  e.target.value =
                                    product.sales[bodyItemIdx] ?? 0;
                                  return;
                                }

                                // Parse the value and update if valid
                                const parsedValue = parseFloat(value);
                                if (
                                  !Number.isNaN(parsedValue) &&
                                  parsedValue >= 0
                                ) {
                                  updateSales({
                                    index: bodyItemIdx,
                                    value: parsedValue,
                                    id: product.id,
                                  });
                                } else if (value === '') {
                                  // Allow empty input
                                  updateSales({
                                    index: bodyItemIdx,
                                    value: 0,
                                    id: product.id,
                                  });
                                } else {
                                  e.target.value =
                                    product.sales[bodyItemIdx] ?? 0;
                                }
                              }}
                              onKeyUp={(e) => {
                                // Update the width machine with current input value after the key is released
                                const widthMachine =
                                  e.target.parentElement.querySelector(
                                    '.width-machine',
                                  );
                                if (widthMachine) {
                                  widthMachine.textContent =
                                    e.target.value || '0';
                                }
                              }}
                              onFocus={(e) => {
                                // Select all text when focused for easy editing
                                e.target.select();
                              }}
                              className="input absolute w-full h-full p-2 text-center bg-transparent border-0 text-slate-900 focus:outline-none focus:ring-0 top-0 left-0"
                              placeholder="0"
                            />
                          </div>
                        </td>
                      );
                    },
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}
